import { lazy } from 'react';
/** Открывает форму блога */
export const BlogFormPageAsync = lazy(() => import('./BlogForm/BlogFormPage'));